import {createContext} from 'react'

export interface InternalBannerRegistryContextValue {
  /** Registers (or unregisters, when `el` is `null`) a banner's rendered root element by id. */
  registerBannerEl: (id: string, el: HTMLElement | null) => void
}

// Kept separate from `InternalBannerStackDataContext` (which holds the frequently
// changing `banners` array) so that `BannerStackOutlet` doesn't re-render on every
// banner add/dismiss just because it also needs this stable registration function.
export const InternalBannerRegistryContext = createContext<InternalBannerRegistryContextValue>({
  registerBannerEl: () => {},
})
